import { TranslationChunksConfig, translationChunksConfig } from '@spartacus/assets'
import { orderTranslationChunksConfig } from '@spartacus/order/assets'

export const ebTranslationChunksConfig: TranslationChunksConfig = {
  myAccount: ['statusText', 'favorites'],
  order: [...orderTranslationChunksConfig.order, 'orderHistoryList', 'orderDetails'],
  product: [
    'productDetail',
    'productGrid',
    'productVariant',
    'productGridItem',
    'productVariantList',
    'TabPanelContainer',
    'addToCart',
    'addFavoritesToCart',
    'availability',
    'selectBox',
    'prices',
    'successor',
    'unitSelector'
  ],
  common: [...translationChunksConfig.common, 'siteContextSelector', 'sso', 'field'],
  checkoutOrderConfirmation: ['checkoutOrderConfirmation'],
  checkout: [
    'checkout',
    'checkoutProgress',
    'deliveryAddress',
    'shippingAddress',
    'deliveryMode',
    'checkoutReview',
    'checkoutShipping',
    'checkoutPO'
  ],
  address: ['addressForm', 'addressCard'],
  consentManagement: ['form', 'consentManagement'],
  cart: ['cartDetails', 'orderCost', 'cartItems', 'empty', 'businessPartner'],
  support: ['rfp', 'contact', 'contactCard'],
  quickOrder: ['quickOrder', 'csv'],
  checkoutB2B: ['checkoutB2B']
}

export const ebI18nChunkConfig = {
  chunks: {
    ...translationChunksConfig,
    ...ebTranslationChunksConfig
  }
}
